import { gql, TypedDocumentNode } from "@apollo/client";

import {
  UpdateUserFfSegmentMutation,
  UpdateUserFfSegmentMutationVariables,
} from "./UpdateUserFfSegment.generated";

const UPDATE_USER_FF_SEGMENT: TypedDocumentNode<
  UpdateUserFfSegmentMutation,
  UpdateUserFfSegmentMutationVariables
> = gql`
  mutation UpdateUserFFSegment(
    $action: ActionEnum!
    $segmentKey: String!
  ) {
    updateUserFfSegment(action: $action, segmentKey: $segmentKey) {
      success
      message
    }
  }
`;

export default UPDATE_USER_FF_SEGMENT;
